export const urlSafeFileName = (fileName = '') => {
  const spaceRegex = new RegExp(' +', 'g');
  const replaced = fileName.replace(spaceRegex, '_').replace(/[^a-zA-Z0-9.]/g, '');

  return replaced;
};
